import React from "react";
// import ReactDOM from 'react-dom';
import "antd/dist/antd.css";
import { Table, Empty } from "antd";
import ReportCell from "../Cell/ReportCell";
import SignatureCell from "../Cell/SignatureCell";
import moment from "moment";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import _ from "lodash";
import HotelNavigation from "../Navigation/HotelNavigation";
import CustomHeaderWithTooltip from "../../../Common/EnduserTooltip/index";
// import { RightSquareOutlined, LeftSquareOutlined, InfoCircleOutlined } from '@ant-design/icons';

import commonConfig from "../../../../commonConfig.json";

let customTabView = commonConfig.customTabView;

class HorizontalTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisibleToolTip: false,
      columns: [],
      data: [],
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      // selectedHotels: [],
      // currentViewIndexes: this.props.settings.indexes
    };

    this.hideOnTrigger = this.hideOnTrigger.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.changeHotelView = this.changeHotelView.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions = () => {
    this.setState({
      winWidth: window.innerWidth,
      // winHeight: window.innerHeight
    });
  };

  componentDidMount() {
    window.addEventListener("resize", () => this.updateDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.updateDimensions());
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.qmsApi.complianceTableData[this.props.customTabView] !==
        prevProps.qmsApi.complianceTableData[this.props.customTabView] ||
      this.props.status !== prevProps.status ||
      this.props.customTabView !== prevProps.customTabView
    ) {
      // || this.props.qmsApi.customTabViewComplianceTableData !== prevProps.qmsApi.customTabViewComplianceTableData)
      //gen state popup
      this.renderTable();
    }
  }

  hideOnTrigger = (value) => {
    this.setState({ isVisibleToolTip: value });
  };

  // this method will render the table columns headers and feeding main datasource array(row records data)
  renderTable = () => {
    var default_report_type_view = this.props.status;
    let complianceData = [];
    // if(this.props.customTabView === customTabView.CUSTOM){
    //   complianceData = this.props.qmsApi.customTabViewComplianceTableData;
    // } else{
    //   complianceData = this.props.qmsApi.complianceTableData;
    // }
    complianceData =
      this.props.qmsApi.complianceTableData[this.props.customTabView] !==
      undefined
        ? this.props.qmsApi.complianceTableData[this.props.customTabView]
        : [];
    if (complianceData.length !== 0) {
      var _data = [];
      var _columns = [];
      // let _state = this.state;
      // let _this = this;
      // if(this.props.customTabView == )
      complianceData.forEach((value, index) => {
        var temp_item_0 = value[0];
        var temp_item_0_key = _.keys(temp_item_0)[0];
        var column_hotel_template = [];

        let headerStyle = { textAlign: "center" };

        // if (default_report_type_view === 'All') {
        column_hotel_template = temp_item_0[temp_item_0_key].reports.map(
          (item) => {
            const _key = item.hotel + "-" + item.hotelEnv;
            let header =
              (item.hotelCode !== "" && item.hotel !== ""
                ? item.hotelCode + " - " + item.hotel
                : item.hotelEnv === "Marriott"
                ? item.hotelCode
                : item.hotel) +
              (item.qcType !== "" ? " (" + item.qcType + ")" : "");

            if (item.softLiveStyle) {
              header = (
                <>
                  {header}{" "}
                  <span style={{ color: "black", float: "right" }}>
                    Soft Live
                  </span>
                </>
              );
            }

            if (default_report_type_view === "All") {
              return {
                title: () => {
                  return <div style={headerStyle}>{header}</div>;
                },
                className: item.softLiveStyle ? "softLiveGreen" : "",
                children: [
                  {
                    className: item.softLiveStyle ? "softLiveGreen" : "",
                    title: () => {
                      return (
                        <div style={{ textAlign: "center" }}>
                          <CustomHeaderWithTooltip
                            title={"Report Status"}
                            visible={this.state.isVisibleToolTip}
                            onHide={this.hideOnTrigger}
                          />
                        </div>
                      );
                    },
                    dataIndex: "reportStatus",
                    key: "reportStatus",
                    width: 200,
                    onHeaderCell: (column) => {
                      return {
                        onClick: () => {
                          this.setState({ isVisibleToolTip: true });
                        },
                      };
                    },
                    render: (statuses, record) => (
                      <>
                        {statuses[record.id.findIndex((k) => k === _key)].value}
                      </>
                    ),
                  },
                  {
                    className: item.softLiveStyle ? "softLiveGreen" : "",
                    title: () => {
                      return (
                        <div style={{ textAlign: "center" }}>
                          <CustomHeaderWithTooltip
                            title={"Signature Status"}
                            visible={this.state.isVisibleToolTip}
                            onHide={this.hideOnTrigger}
                          />
                        </div>
                      );
                    },
                    dataIndex: "signatureStatus",
                    onHeaderCell: (column) => {
                      return {
                        onClick: () => {
                          this.setState({ isVisibleToolTip: true });
                        },
                      };
                    },
                    key: "signatureStatus",
                    width: 200,
                    render: (statuses, record) => (
                      <>
                        {statuses[record.id.findIndex((k) => k === _key)].value}
                      </>
                    ),
                  },
                ],
              };
            } else if (default_report_type_view === "Report Status") {
              // const _key = item.hotel + '-' + item.hotelEnv;
              // const header = ((item.hotelCode !== "" && item.hotel !== "") ? item.hotelCode + " - " + item.hotel: ((item.hotelEnv === "Marriott") ? item.hotelCode : item.hotel)) + ((item.qcType !== "") ? (" (" + item.qcType + ")") : "");
              return {
                className: item.softLiveStyle ? "softLiveGreen" : "",
                title: () => {
                  return <div style={{ textAlign: "center" }}>{header}</div>;
                },
                children: [
                  {
                    className: item.softLiveStyle ? "softLiveGreen" : "",
                    title: () => {
                      return (
                        <div style={{ textAlign: "center" }}>
                          <CustomHeaderWithTooltip
                            title={"Report Status"}
                            visible={this.state.isVisibleToolTip}
                            onHide={this.hideOnTrigger}
                          />
                        </div>
                      );
                    },
                    dataIndex: "reportStatus",
                    key: "reportStatus",
                    width: 200,
                    onHeaderCell: (column) => {
                      return {
                        onClick: () => {
                          this.setState({ isVisibleToolTip: true });
                        },
                      };
                    },
                    render: (statuses, record) => (
                      <>
                        {statuses[record.id.findIndex((k) => k === _key)].value}
                      </>
                    ),
                  },
                ],
              };
            } else if (default_report_type_view === "Signature Status") {
              // const _key = item.hotel + '-' + item.hotelEnv;
              // const header = ((item.hotelCode !== "" && item.hotel !== "") ? item.hotelCode + " - " + item.hotel: ((item.hotelEnv === "Marriott") ? item.hotelCode : item.hotel)) + ((item.qcType !== "") ? (" (" + item.qcType + ")") : "");
              return {
                className: item.softLiveStyle ? "softLiveGreen" : "",
                title: () => {
                  return <div style={{ textAlign: "center" }}>{header}</div>;
                },
                children: [
                  {
                    className: item.softLiveStyle ? "softLiveGreen" : "",
                    title: () => {
                      return (
                        <div style={{ textAlign: "center" }}>
                          <CustomHeaderWithTooltip
                            title={"Signature Status"}
                            visible={this.state.isVisibleToolTip}
                            onHide={this.hideOnTrigger}
                          />
                        </div>
                      );
                    },
                    dataIndex: "signatureStatus",
                    key: "signatureStatus",
                    width: 200,
                    onHeaderCell: (column) => {
                      return {
                        onClick: () => {
                          this.setState({ isVisibleToolTip: true });
                        },
                      };
                    },
                    render: (statuses, record) => (
                      <>
                        {statuses[record.id.findIndex((k) => k === _key)].value}
                      </>
                    ),
                  },
                ],
              };
            }
          }
        );

        _columns.push(...column_hotel_template);

        for (var i = 0; i < value.length; i++) {
          var item = value[i];
          var key = _.keys(item)[0];
          //console.log('#Value# ', item[key]);
          //var temp = item[key].reports[0].missingReportList;
          //item[key].reports[0].missingReportList = [];
          //item[key].reports[0].uploadedReportList = temp;
          //item[key].reports[0].signatureCell.type = 1;
          var dateObj = moment(key, "MM-DD-YYYY");
          _data.push({
            date: dateObj.format("MM-DD-YYYY"),
            id:
              item[key].reports[0].hotel + "-" + item[key].reports[0].hotelEnv,
            key:
              item[key].reports[0].hotel + "-" + item[key].reports[0].hotelEnv,
            signatureStatus: {
              key:
                item[key].reports[0].hotel +
                "-" +
                item[key].reports[0].hotelEnv,
              value: (
                <SignatureCell
                  mydocsURL={item[key].reports[0].mydocsSigRedirectUrl}
                  signContnent={item[key].reports[0].signatureDetails}
                  reportContent={{
                    mis_reports: item[key].reports[0].missingReportList,
                    up_reports: item[key].reports[0].uploadedReportList,
                  }}
                  status={item[key].reports[0].signatureCell}
                  basicCellData={{
                    hmg: item[key].reports[0].hmg,
                    hotelEnv: item[key].reports[0].hotelEnv,
                    bdate: item[key].reports[0].date,
                  }}
                  idKey={
                    item[key].reports[0].hotel +
                    ":" +
                    item[key].reports[0].date +
                    ":" +
                    item[key].reports[0].hotelEnv +
                    ":" +
                    item[key].reports[0].hotelCode
                  }
                />
              ),
            },
            reportStatus: {
              key:
                item[key].reports[0].hotel +
                "-" +
                item[key].reports[0].hotelEnv,
              value: (
                <ReportCell
                  mydocsURL={item[key].reports[0].mydocsRedirectUrl}
                  reportContent={{
                    mis_reports: item[key].reports[0].missingReportList,
                    up_reports: item[key].reports[0].uploadedReportList,
                  }}
                  status={item[key].reports[0].reportCell}
                  idKey={
                    item[key].reports[0].hotel +
                    ":" +
                    item[key].reports[0].date +
                    ":" +
                    item[key].reports[0].hotelEnv +
                    ":" +
                    item[key].reports[0].hotelCode
                  }
                />
              ),
            },
          });
        }
      });
      // console.log("Matrix", cellMatrix)
      // this.props.createPopupMatrix(cellMatrix)
      const temp_holder = this.groupBy(_data, "date");
      this.setState((state) => {
        const date_colmun = {
          title: "Business Date",
          width: 100,
          dataIndex: "date",
          key: "date",
          fixed: "left",
        };
        _columns.unshift(date_colmun);
        return {
          columns: _columns,
          data: temp_holder,
        };
      });
    } else {
      // message.error("There is no valid compliance data to proceed");
      this.setState({
        columns: [],
        data: [],
      });
    }
  };

  groupBy = function (xs, key) {
    let temp_final = _(xs)
      .groupBy(key)
      .map(function (item, index) {
        return {
          date: index,
          id: _.map(item, "id"),
          signatureStatus: _.map(item, "signatureStatus"),
          reportStatus: _.map(item, "reportStatus"),
        };
      })
      .value();

    return temp_final;
  };

  statusOnClick = () => {
    //console.log('status onclick');
  };

  showTotal = (total) => {
    return `${total} of hotels`;
  };

  changeHotelView = (value) => {
    this.props.changeHotelView(value);
  };

  render() {
    return (
      <div>
        <Table
          className="complianceTable"
          columns={this.state.columns}
          dataSource={this.state.data}
          bordered
          pagination={false}
          size={this.state.winWidth < 768 ? "small" : "middle"}
          // size="middle"
          // scroll={{ x: "100%", y: 540 }}
          id="compDatatableH"
          key="compDatatableH"
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No File Found"
              />
            ),
          }}
          // scroll={{ x: "max-content", y: 540 }}
          scroll={{
            x:
              this.state.winWidth >= 1200
                ? 1000
                : this.state.winWidth >= 768
                ? 500
                : "max-content",
            y: 540,
          }}
        />
        {/* {console.log(this.props.settings, this.props.selectedHotels, "Horizontal View")} */}
        <HotelNavigation
          settings={this.props.settings}
          changeHotelViewEvent={this.changeHotelView}
          // selectedHotels={this.props.selectedHotels}
          // emptyData={this.props.customTabView === customTabView.CUSTOM ? this.props.qmsApi.customTabViewComplianceTableData.length : this.props.qmsApi.complianceTableData.length}
          emptyData={
            this.props.qmsApi.complianceTableData[this.props.customTabView] !==
            undefined
              ? this.props.qmsApi.complianceTableData[this.props.customTabView]
                  .length
              : 0
          }
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    qmsApi: state.qmsApi,
    status: state.complianceTableReducer.status,
    // customTabView:state.complianceTableReducer.customTabView
    customTabView: state.appPermissionsReducer.complianceMainTabData.active,
    // transpose: state.complianceTableReducer.transpose,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      // createPopupMatrix : actions.createPopupMatrix
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(HorizontalTable);
